import {Controller} from "@hotwired/stimulus"

class SearchFieldController extends Controller {
  static targets = ["field"]
  static values = {forArticles: Boolean}

  connect() {
    this.callback = this.on_before_render.bind(this)
    document.addEventListener("turbo:before-render", this.callback)
  }

  disconnect() {
    document.removeEventListener("turbo:before-render", this.callback)
  }

  open_search_page() {
    if (this.search_was_triggered) return

    this.search_was_triggered = true
    window.Turbo.visit(window.gon.search_path)
  }

  on_before_render() {
    if (!this.search_was_triggered) return
    if (window.location.pathname !== window.gon.search_path) return

    const url = new URL(window.gon.search_path, window.location)
    const q = this.fieldTarget.value
    if (q) url.searchParams.set("q", q)
    if (this.forArticlesValue) {
      url.searchParams.set("for_articles", "true")
    }
    this.search_was_triggered = false
    window.history.replaceState(window.history.state, null, url)
  }
}

export default SearchFieldController
